import React from "react";

const Newsletter = () => {
  return (
    <div className="flex bg-[#F9FAFB] rounded-gr justify-center mt-12 p-[64px] sm:mx-0 mx-[20px]">
      <div className="flex flex-col lg:gap-[240px] gap-[40px] lg:flex-row justify-center self-center">
        <div className="flex flex-col lg:ml-10 xl:ml-[-50px]">
          <h2 className="font-[700] text-[30px] leading-[45px] max-w-[300px] font-plus-jakarta-sans text-[#101828] lg:max-w-[400px]">
            Sign up for our newsletter
          </h2>
          <p className="font-[400] text-[20px] leading-[30px] font-plus-jakarta-sans text-[#475467] max-w-[320px] lg:w-full mt-4 lg:max-w-[500px]">
            Stay in the loop with everything you need to know.
          </p>
        </div>
        <div className="flex flex-col lg:flex-row gap-[10px] lg:ml-24">
          <div className="flex flex-col lg:flex-col">
            <input
              type="text"
              placeholder="    Enter you email"
              className="border-[2px] h-[48px] w-[344px] rounded-[5px] placeholder-[#667085] text-lg"
            ></input>
            <p className=" font-[400] text-[14px] leading-[20px] w-[250px] lg:w-full text-[#475467] mt-4">
              We care about your data in our{" "}
              <a className="text-[#475467] decoration-solid">
                <u>privacy policy.</u>
              </a>{" "}
            </p>
          </div>
          <button className="mw-[295px] w-full h-[48px] p-[18px] border-[1px]  bg-Yellow cursor-pointer relative rounded-[9px] text-[1rem] text-center flex justify-center lg:w-[120px] lg:h-[48px] mt-1">
            <p className="self-center font-[700] text-[16px] leading-[24px]">
              Subscribe
            </p>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Newsletter;
